import React from "react";
import PropTypes from "prop-types";
import cname from "./style.module.scss";
import { Icons } from "@learningblocks/exp-constants";

const { ChevronDownSolid: OpenIcon } = Icons;
/**
 * AccordianTab:
 *  - A single tab in an accordian component
 */
export function AccordianTab(props) {
  const setCname = (className = "") => {
    if (props.open) {
      className += ` ${cname.visible}`;
    } else {
      className += ` ${cname.hidden}`;
    }
    return className;
  };

  // const onKeyDown = (event) => event.keyCode && props.onKeyDown();

  return (
    <li
      role="option"
      aria-selected={props.description}
      tabIndex={props.tabIndex || 0}
      className={setCname()}
      onKeyDown={props.onKeyDown}
      onClick={props.onClick}
    >
      <div className={cname.titleBlock}>
        <p>{props.label}</p>
        <OpenIcon className={cname.icon} />
      </div>
      <div className={cname.descriptionBlock}>
        <p>{props.description}</p>
      </div>
    </li>
  );
}

AccordianTab.propTypes = {
  /**
   * Label of the tab
   */
  label: PropTypes.string,
  /**
   * Description of the tab
   */
  description: PropTypes.string,
  /**
   * Boolen set for when tab is open/close
   */
  open: PropTypes.bool,
  /**
   * Callback for when a tab is clicked
   */
  onClick: PropTypes.func,
  /**
   * keyboard accessibility
   */
  tabIndex: PropTypes.string,
};

AccordianTab.defaultProps = {
  label: "",
  description: "",
  open: false,
};
